import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from '../views/home/index.vue';
import HomeMain from '../views/homeMain/index.vue';
import Experience from '../views/experience/index.vue';
import Infertilitet from '../views/infertilitet/index.vue';
import Help from '../views/help/index.vue';
import Terapi from '../views/terapi/index.vue';
import Kontakt from '../views/kontakt/index.vue';
import Prise from '../views/prise/index.vue';
import AkupunkturIKina from '../views/akupunkturIKina/index.vue';
import Dags from '../views/dags/index.vue';
import Nyheter from '../views/nyheter/index.vue';
import BehandLingar from '../views/behandLingar/index.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    component: HomePage,
    children: [
      {
        path: '',
        name: 'HomeMain',
        component: HomeMain
      },
      {
        path: 'experience',
        name: 'Experience',
        component: Experience
      },
      {
        path: 'infertilitet',
        name: 'Infertilitet',
        component: Infertilitet
      },
      {
        path: 'help',
        name: 'Help',
        component: Help
      },
      {
        path: '/terapi',
        name: 'Terapi',
        component: Terapi
      },
      {
        path: '/kontakt',
        name: 'Kontakt',
        component: Kontakt
      },
      {
        path: '/full-screen-image',
        name: 'FullScreenImage',
        component: () => import('@/views/kontakt/fullScreenImage.vue')
      },
      {
        path: '/prise',
        name: 'Prise',
        component: Prise
      },
      {
        path: '/akupunkturIKina',
        name: 'AkupunkturIKina',
        component: AkupunkturIKina
      },
      {
        path: '/dags',
        name: 'Dags',
        component: Dags
      },
      {
        path: '/nyheter',
        name: 'Nyheter',
        component: Nyheter
      },
      {
        path: '/nyheterDetail/:id',
        component: () => import('@/views/nyheter/nyheterDetail.vue')
      },
      {
        path: '/behandLingar',
        name: 'BehandLingar',
        component: BehandLingar
      },
      {
        path: '/doctorCard',
        component: () => import('@/views/doctorCard/doctorCard.vue')
      },
      {
        path: '/peosonInfo',
        name: 'PeosonInfo', // 添加 name 属性便于导航
        component: () => import('@/views/peosonInfo/index.vue')
      },
    ]
  }
];

const router = new VueRouter({
  mode: 'history', // 确保使用 history 模式以支持锚点
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (to.hash) {
      return {
        selector: to.hash,
        behavior: 'smooth',
      };
    }
    return savedPosition || { x: 0, y: 0 };
  },
});

export default router;
